import {
  fetchInProgressTests,
  fetchPendingTests,
  fetchCompletedTests,
  TestsFetchResponse
} from 'common/modules/ReactShared/data/api/tests';
import * as Template from '../../_pagination';
import { tTestsTab } from './types';

const FETCHERS: Record<
  tTestsTab,
  (args?: Template.IParams) => Promise<TestsFetchResponse>
> = {
  in_progress: fetchInProgressTests,
  pending: fetchPendingTests,
  completed: fetchCompletedTests
};

export { FETCHERS };
